<template lang="pug">
  SspLayout(area="core")
    .row
      .col-md-12
        .panel.panel-default
          .panel-heading
            h3.panel-title Schema Definition
          .panel-body
            PrettyJson.pretty-json(:jsonObject="metadataSchema")
</template>

<script>
import Activator from '@/service/apis/Activator'
import PrettyJson from '@/components/common/PrettyJson'

export default {
  data: () => ({
    metadataSchema: null
  }),
  created() {
    Activator.getSchemaById(this.schemaId)
      .then((resp) => {
        this.metadataSchema = resp.data
      })
  },
  computed: {
    schemaId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    PrettyJson
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/metadataschema/ViewMetadataSchema.vue